import React from 'react';
import { StudyGuideModalLegendBrain } from './study-guide-modal-legend-brain';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import { GuideLvl, GuideLvlContent, GuideLvlItem, GuideLvlSubtitle, GuideLvlTitle } from '@/components/custom/guide';

export function StudyGuideModalLegend() {
  return (
    <DialogContent
      size="lg"
      className="bg-bright md:p-10"
    >
      <DialogTitle className="mb-4">Nível de progresso de conteúdo</DialogTitle>

      <GuideLvl>
        <GuideLvlItem>
          <StudyGuideModalLegendBrain percentage={0} />

          <GuideLvlContent>
            <GuideLvlTitle>Começando a entender</GuideLvlTitle>
            <GuideLvlSubtitle>Você está dando os primeiros passos no aprendizado deste conteúdo. As informações ainda são novas, e é normal que leve um tempo para assimilar tudo. Continue estudando para aprofundar o entendimento.</GuideLvlSubtitle>
          </GuideLvlContent>
        </GuideLvlItem>
        <GuideLvlItem>
          <StudyGuideModalLegendBrain percentage={21} />

          <GuideLvlContent>
            <GuideLvlTitle>Ganhando clareza</GuideLvlTitle>
            <GuideLvlSubtitle>Você já está começando a se familiarizar com os conceitos. O conhecimento está se firmando e as ideias estão ficando mais claras. Mantenha o ritmo para solidificar o aprendizado.</GuideLvlSubtitle>
          </GuideLvlContent>
        </GuideLvlItem>
        <GuideLvlItem>
          <StudyGuideModalLegendBrain percentage={41} />

          <GuideLvlContent>
            <GuideLvlTitle>Conteúdo assimilado</GuideLvlTitle>
            <GuideLvlSubtitle>Você já absorveu boa parte do conteúdo e está se tornando mais confiante. Os conceitos principais estão sendo compreendidos, e você está no caminho certo para dominar o assunto.</GuideLvlSubtitle>
          </GuideLvlContent>
        </GuideLvlItem>
        <GuideLvlItem>
          <StudyGuideModalLegendBrain percentage={61} />

          <GuideLvlContent>
            <GuideLvlTitle>Boa retenção</GuideLvlTitle>
            <GuideLvlSubtitle>Você está retendo a maior parte do conteúdo com sucesso. Suas habilidades e conhecimento estão bem desenvolvidos, e você está quase pronto para aplicar o que aprendeu de forma prática.</GuideLvlSubtitle>
          </GuideLvlContent>
        </GuideLvlItem>
        <GuideLvlItem>
          <StudyGuideModalLegendBrain percentage={81} />

          <GuideLvlContent>
            <GuideLvlTitle>Ótima retenção</GuideLvlTitle>
            <GuideLvlSubtitle>Parabéns! Você atingiu um nível excelente de retenção de conhecimento. Agora, você domina o conteúdo e está preparado para utilizá-lo com confiança em diferentes contextos.</GuideLvlSubtitle>
          </GuideLvlContent>
        </GuideLvlItem>
      </GuideLvl>
    </DialogContent>
  );
}
